export const adminRoutes = {
  surveyExport: "survey/:id",
  userBulkUpload: "user-bulk-upload",
  addressBulkUpload: "address-bulk-upload",
  companyBulkUpload: "company-bulk-upload",
} as const;
